"use client";

import { Message } from "@faire/slate/foundation/color";
import { eventsThemeColors } from "@faire/web/slate/Theme/eventsThemeColors";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

interface IBrandPromoTextProps {
  promoText: string | undefined;
  isHighlightedPromo?: boolean;
}

export const BrandPromoText: React.FC<IBrandPromoTextProps> = ({
  isHighlightedPromo,
  promoText,
}) => {
  if (!promoText) {
    return null;
  }
  return (
    <>
      {isHighlightedPromo ? (
        <Typography
          data-test-id="highlighted-promo-text"
          variant="paragraphSansMedium"
          color={eventsThemeColors.faireMarket.promoText}
        >
          {promoText}
        </Typography>
      ) : (
        <NoneHighlightPromoText promoText={promoText} />
      )}
    </>
  );
};

const NoneHighlightPromoText: React.FC<{
  promoText: string;
}> = ({ promoText }) => {
  return (
    <StyledContainer>
      <Typography
        data-test-id="non-highlighted-promo-text"
        variant="paragraphSansRegular"
        color={Message.text.sale}
      >
        {promoText}
      </Typography>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  width: 100%;
`;
